export const SERVICES_ROOT = "/services"